import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import i18n from './i18next.config'

/**
 * Extract i18n namespaces from route modules exposed by React Router v7.
 * Replaces remix-i18next/client's getInitialNamespaces which reads the
 * now-removed window.__remixRouteModules global.
 */
function getInitialNamespaces(): string[] {
  const routeModules =
    (window as Record<string, unknown>).__reactRouterRouteModules ?? (window as Record<string, unknown>).__remixRouteModules

  if (!routeModules || typeof routeModules !== 'object') return []

  return Object.values(routeModules as Record<string, { handle?: { i18n?: string | string[] } }>).flatMap((route) => {
    if (typeof route?.handle !== 'object' || !route.handle || !('i18n' in route.handle)) return []
    if (typeof route.handle.i18n === 'string') return [route.handle.i18n]
    if (Array.isArray(route.handle.i18n) && route.handle.i18n.every((v) => typeof v === 'string')) {
      return route.handle.i18n
    }
    return []
  })
}

async function initializeClientI18n() {
  await i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(Backend)
    .init({
      ...i18n,
      fallbackLng: i18n.fallbackLanguage,
      supportedLngs: i18n.supportedLanguages,
      ns: [...i18n.defaultNS, ...getInitialNamespaces()],
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        requestOptions: {
          cache: 'no-store',
        },
      },
      detection: {
        order: ['htmlTag'],
        caches: [],
      },
    })

  return i18next
}

export default initializeClientI18n
